export default __webpack_public_path__ + "static/media/corporate10.0ace66d0.jpg";